<template>
  <validation-observer
    ref="rejectForm"
    #default="{invalid}"
  >
    <b-form>
      <b-form-group
        label-for="reject-reason"
      >
        <template v-slot:label>
          Lý do từ chối <span class="text-danger">*</span>
        </template>
        <validation-provider
          v-slot="{ errors }"
          name="Lý do từ chối"
          rules="required|min:10"
        >
          <b-form-textarea
            id="reject-reason"
            v-model="rejectReason"
            placeholder="Nhập lý do từ chối (ít nhất 10 ký tự)"
            rows="4"
            :state="errors.length > 0 ? false : null"
          />
          <small class="text-danger">{{ errors[0] }}</small>
        </validation-provider>
      </b-form-group>
    </b-form>
    <div class="w-100 d-flex justify-content-end">
      <b-button
        v-ripple.400="'rgba(255, 255, 255, 0.15)'"
        class="mr-1"
        variant="outline-secondary"
        @click="onCancel"
      >
        <span class="text-right">
          <feather-icon icon="XIcon" /> Hủy
        </span>
      </b-button>
      <b-button
        v-ripple.400="'rgba(255, 255, 255, 0.15)'"
        variant="danger"
        :disabled="invalid"
        @click="onSubmit"
      >
        <span class="text-right">
          <feather-icon icon="CheckIcon" /> Xác nhận từ chôi
        </span>
      </b-button>

    </div>
  </validation-observer>
</template>

<script>
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import { required, min } from '@validations'
import {
  BButton, BForm, BFormGroup, BFormTextarea,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import api from './api'

export default {
  name: 'RejectReasonModal',
  components: {
    BButton,
    ValidationObserver,
    ValidationProvider,
    BForm,
    BFormGroup,
    BFormTextarea,
  },
  directives: {
    Ripple,
  },
  props: {
    studentId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      rejectReason: '',
      required,
      min,
    }
  },
  methods: {
    async onSubmit() {
      try {
        const response = await api.rejectStudentChangeRequest(this.studentId, { reason: this.rejectReason })
        if (response) {
          const { isSuccessful, message } = response
          if (isSuccessful) {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: message,
                icon: 'CheckIcon',
                variant: 'success',
              },
            })
            this.$emit('rejected')
            this.resetForm()
          } else {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: message,
                icon: 'XCircleIcon',
                variant: 'danger',
              },
            })
          }
        }
      } catch (e) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: `[${e.code}] ${e.message}`,
            icon: 'XCircleIcon',
            variant: 'danger',
          },
        })
      } finally {
        this.isLoading = false
      }
    },
    onCancel() {
      this.$emit('cancel')
      this.resetForm()
    },
    resetForm() {
      this.rejectReason = ''
      this.$nextTick(() => {
        this.$refs.rejectForm.reset()
      })
    },
  },
}
</script>
